import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c61986f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mode-wrap",
  role: "group",
  "aria-label": "模式切换"
}
const _hoisted_2 = { class: "switch" }
const _hoisted_3 = ["checked", "aria-checked"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleSwitch',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

// eslint-disable-next-line @typescript-eslint/no-unused-vars



function onChange(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).checked)
}
function setMode(v: boolean) {
  emit('update:modelValue', v)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["label", { active: !_ctx.modelValue }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setMode(false))),
      "aria-pressed": "!modelValue"
    }, " view mode ", 2),
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        checked: _ctx.modelValue,
        onChange: onChange,
        role: "switch",
        "aria-checked": _ctx.modelValue ? 'true' : 'false',
        "aria-label": "切换查看/编辑"
      }, null, 40, _hoisted_3),
      _hoisted_4
    ]),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["label", { active: _ctx.modelValue }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setMode(true))),
      "aria-pressed": "modelValue"
    }, " edit mode ", 2)
  ]))
}
}

})